export default __webpack_public_path__ + "static/media/instagram_icon.b32856da.svg";